import type { Track, Timeline, AnimationIR } from "../ir";
import type { LogoAnalysis } from "../analyze";

export function baseTimeline(ir: AnimationIR, logo: LogoAnalysis): Omit<Timeline, "tracks"> {
  // Speed nudges duration mildly — clamp the effective multiplier so a
  // mis-tuned IR can never produce a 10-second logo reveal. The IR schema
  // already clamps speed to [0.7, 1.4]; this is the second line of defense.
  const speed = Math.max(0.85, Math.min(1.2, ir.speed));
  const raw = Math.round(ir.durationMs / speed);
  // Absolute cinema cap — past ~3.2s a reveal stops reading as "polish" and
  // starts reading as "the page isn't loading".
  const totalMs = Math.max(700, Math.min(3200, raw));
  return {
    durationMs: totalMs,
    fps: 60,
    width: 1080,
    height: 1080,
    background: ir.colorOverrides?.transparent
      ? "transparent"
      : ir.colorOverrides?.background ?? "#0a0a0a",
    effects: ir.effects,
  };
}

export function pathTargets(logo: LogoAnalysis): string[] {
  if (logo.paths.length === 0) return ["[data-id]"];
  return logo.paths.map((_, i) => `[data-id="p${i}"]`);
}

export const ROOT_TARGET = "[data-logo-root]";
